import {
  AGENCY_DSWD_ID,
  AGENCY_DOH_ID,
  AGENCY_CHED_ID,
  AGENCY_DOLE_ID,
  AGENCY_DBM_ID,
  AGENCY_TESDA_ID,
} from "constants/agency";
import {
  APPROVED_STATUS_LABEL,
  DISAPPROVED_STATUS_LABEL,
} from "constants/status";

export const modifiedStatuses = {
  Approved: APPROVED_STATUS_LABEL,
  Disapproved: DISAPPROVED_STATUS_LABEL,
};

export const REPORT_COLOR_SCHEMES = {
  [AGENCY_DSWD_ID]: {
    header: "#f2553d",
    rowColumns: "#bc5041",
  },
  [AGENCY_DOH_ID]: {
    header: "#008de9",
    rowColumns: "#0079b4",
  },
  [AGENCY_CHED_ID]: {
    header: "#ff42a1",
    rowColumns: "#b64484",
  },
  [AGENCY_DOLE_ID]: {
    header: "#e56300",
    rowColumns: "#a85600",
  },
  [AGENCY_DBM_ID]: {
    header: "#52ac00",
    rowColumns: "#aad682",
  },
  [AGENCY_TESDA_ID]: {
    header: "#5800c7",
    rowColumns: "#ccb6e8",
  },
};

export const exportOptions = [
  {
    label: "PDF",
    value: "pdf",
  },
  {
    label: "DOC",
    value: "doc",
  },
];

export const styles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F2F2F2",
    border: "1px solid #E5E5E5",
    borderRadius: "6px",
    height: "48px",
    overflow: "auto",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};
